import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { EditableDBItemV3, ModuleFE_MouseInteractivity, mouseInteractivity_PopUp, ProtoComponent } from '@nu-art/thunderstorm-frontend/index';
import { TS_HorizontalWorkspace, TS_Workspace } from '@nu-art/ts-workspace-frontend/index';
import { SearchSelector_BaseManagerUI } from '@app/styles';
import { cloneObj, DefaultNewItemId, exists, resolveContent } from '@nu-art/ts-common';
import { DBDef_FlowSheet, DBDef_LogTemplate, DBDef_NoteTemplate, defaultItem_FlowSheet, defaultItem_LogTemplate, defaultItem_NoteTemplate } from '@app/advisor-content-shared';
import { Editor_FlowSheet } from '../../editors/Editor_FlowSheet/Editor_FlowSheet.js';
import { workspaceKey_Page_SmartDocs } from './workspace.js';
import { Editor_NoteTemplate } from '../../editors/Editor_NoteTemplate/Editor_NoteTemplate.js';
import { Editor_LogTemplate } from '../../editors/Editor_LogTemplate/Editor_LogTemplate.js';
import { ConfigDialogKeys_AdvisorContent, ConfigDialogs_AdvisorContent_Dialogs, ConfigDialogs_AdvisorContent_Labels } from '../../config-dialogs/index.js';
import { ModuleFE_FlowSheet } from '../../../_entity/flow-sheet/ModuleFE_FlowSheet.js';
import { ModuleFE_NoteTemplate } from '../../../_entity/note-template/ModuleFE_NoteTemplate.js';
import { ModuleFE_LogTemplate } from '../../../_entity/log-tempalte/ModuleFE_LogTemplate.js';
import { getSearchableItems_SmartDocs } from '../../editors/searchable-items.js';
export class Page_SmartDocs extends ProtoComponent {
    static defaultProps = {
        keys: ['selected', 'searchItem'],
    };
    // ######################## Life Cycle ########################
    deriveStateFromProps(nextProps, state) {
        state.searchItems ??= getSearchableItems_SmartDocs();
        //Get selectedSearchItem from url
        const selected = this.getQueryParam('selected', {});
        //Get selected search item
        state.selectedSearchItem = undefined;
        for (const searchItem of state.searchItems) {
            const selectedId = selected[searchItem.type];
            if (!exists(selectedId))
                continue;
            state.selectedSearchItem = { type: searchItem.type, id: selectedId };
            break;
        }
        return state;
    }
    // ######################## Logic ########################
    onSearchItemSelected = (item) => {
        const selected = { ...this.getQueryParam('selected', {}) };
        //Clear all selections under this manager
        this.state.searchItems.forEach(searchItem => delete selected[searchItem.type]);
        //Set the selected item
        selected[item.type] = item.id;
        this.setQueryParams({
            selected: selected,
            searchItem: item.type, //Switch the filters in the search panel to the item type
        });
    };
    createNewItem = (dbKey) => {
        ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
        this.onSearchItemSelected({ type: dbKey, id: DefaultNewItemId });
    };
    getEditable = (module, newItemBase) => {
        const id = this.state.selectedSearchItem?.id;
        if (!id)
            return;
        const selectedItem = module.cache.unique(id) ?? cloneObj(resolveContent(newItemBase));
        const editable = new EditableDBItemV3(selectedItem, module);
        editable.setAutoSave(selectedItem._id !== DefaultNewItemId);
        editable.setDebounceTimeout(300);
        editable.setOnSaveCompleted(item => {
            //If the item is newly created, simulate selection for it
            if (id === DefaultNewItemId)
                return this.onSearchItemSelected({ type: module.dbDef.dbKey, id: item._id });
            //Item is not newly created, re-render
            this.forceUpdate();
        });
        return editable;
    };
    deselectItem = (dbKey) => {
        const selected = { ...this.getQueryParam('selected', {}) };
        delete selected[dbKey];
        this.setQueryParam('selected', selected);
    };
    // ######################## Render ########################
    render() {
        return _jsx(TS_Workspace, { workspaceKey: workspaceKey_Page_SmartDocs, renderers: {
                horizontalSpace: TS_HorizontalWorkspace,
            }, instances: {
                list: () => this.renderList(),
                editor: () => this.renderEditor(),
            } });
    }
    renderList = () => {
        return _jsx(SearchSelector_BaseManagerUI, { buttons: [
                {
                    label: 'Add New',
                    action: (e) => {
                        const buttonBox = e.currentTarget.getBoundingClientRect();
                        const model = {
                            id: 'advisor-context-editor__add-new-popup',
                            originPos: {
                                x: buttonBox.x + buttonBox.width + 10,
                                y: buttonBox.y + (buttonBox.height / 2),
                            },
                            modalPos: { x: 1, y: 0 },
                            content: () => {
                                return _jsx(_Fragment, { children: this.state.searchItems.map(searchItem => _jsx("div", { onClick: () => this.createNewItem(searchItem.type), children: searchItem.entityLabel }, searchItem.type)) });
                            },
                        };
                        ModuleFE_MouseInteractivity.showContent(model);
                    }
                },
                {
                    label: 'Configs',
                    action: (e) => {
                        const buttonBox = e.currentTarget.getBoundingClientRect();
                        const model = {
                            id: 'advisor-context-editor__add-new-popup',
                            originPos: {
                                x: buttonBox.x + buttonBox.width + 10,
                                y: buttonBox.y + (buttonBox.height / 2),
                            },
                            modalPos: { x: 1, y: 0 },
                            content: () => {
                                return _jsx(_Fragment, { children: ConfigDialogKeys_AdvisorContent.map(key => {
                                        const label = ConfigDialogs_AdvisorContent_Labels[key];
                                        const dialog = ConfigDialogs_AdvisorContent_Dialogs[key];
                                        return _jsx("div", { onClick: () => {
                                                ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
                                                dialog.show();
                                            }, children: label }, key);
                                    }) });
                            },
                        };
                        ModuleFE_MouseInteractivity.showContent(model);
                    }
                }
            ], searchItems: this.state.searchItems, onSearchItemSelected: this.onSearchItemSelected, selectedItem: this.state.selectedSearchItem });
    };
    renderEditor = () => {
        switch (this.state.selectedSearchItem?.type) {
            case DBDef_FlowSheet.dbKey:
                return this.renderEditor_FlowSheet();
            case DBDef_NoteTemplate.dbKey:
                return this.renderEditor_NoteTemplate();
            case DBDef_LogTemplate.dbKey:
                return this.renderEditor_LogTemplate();
            default:
                return _jsx(_Fragment, {});
        }
    };
    // ######################## Render - Editors ########################
    renderEditor_FlowSheet = () => {
        const editable = this.getEditable(ModuleFE_FlowSheet, defaultItem_FlowSheet);
        if (!editable)
            return _jsx(_Fragment, {});
        return _jsx(Editor_FlowSheet, { editable: editable, deselect: () => this.deselectItem(DBDef_FlowSheet.dbKey) });
    };
    renderEditor_NoteTemplate = () => {
        const editable = this.getEditable(ModuleFE_NoteTemplate, defaultItem_NoteTemplate);
        if (!editable)
            return _jsx(_Fragment, {});
        return _jsx(Editor_NoteTemplate, { editable: editable, deselect: () => this.deselectItem(DBDef_NoteTemplate.dbKey) });
    };
    renderEditor_LogTemplate = () => {
        const editable = this.getEditable(ModuleFE_LogTemplate, defaultItem_LogTemplate);
        if (!editable)
            return _jsx(_Fragment, {});
        return _jsx(Editor_LogTemplate, { editable: editable, deselect: () => this.deselectItem(DBDef_LogTemplate.dbKey) });
    };
}
//# sourceMappingURL=Page_SmartDocs.js.map